export const FILTER_ENDPOINT = '/classifieds/classifieds/filters_v2/'
export const OTP_GENERATE_ENDPOINT = '/login/otp/generate/'
export const OTP_VERIFY_ENDPOINT = '/login/otp/verify/'
export const OTP_VERIFY_ENTERPRISE_ENDPOINT = '/login/otp/verify-enterprise/'
export const LOGIN_PASSWORD_VERIFY = '/login/password/verify/'
export const OTP_RESEND_ENDPOINT = '/login/otp/resend/'
export const LOGOUT_ENDPOINT = '/login/otp/logout/'
export const LOCATION_ENDPOINT = '/locations/'
export const RECOMMENDATIONS_ENDPOINT = '/classifieds/classifieds/recommendations_v2/'
export const SEEKERS_LOCATIONS = '/v3/locations/'
export const LOCATION_BASED_FUZZY_SEARCH_JOBS = `/classifieds/classifieds/filter_jobs_on_location/`
export const ADVERTISER_PROFILE_DETAILS = '/advertisers/v1/profile/me'

export const HEADERS = {
  'Content-Type': 'application/json'
}

export const APPLY_JOB_END_URL = '/classifieds/classifieds/784/apply/?type=0'



export const APPLY_FILTERS_END_URL = '/classifieds/classifieds/apply_filters_v2/'

export const FEED_V2_END_URL = '/classifieds/classifieds/feed_v2/'

export const JOB_SEARCH_APPLY = '/classifieds/job_seeker/job_search_apply/'

export const SEARCH_END_URL = '/classifieds/classifieds/search_suggestions/'

export const PROMOTED_JOBS_END_URL = '/classifieds/classifieds/promoted_jobs_v2/'

export const DRAFT_END_URL = '/submissions/draft/'

export const SUBMISSION_DETAILS = '/submissions/submissions/'

export const CREAT_JOB_STATUS = '/classifieds/job_seeker/'

export const ADVERTISER_CATEGORIES = '/classifieds/get_job_categories/'
export const ADVERTISER_LOCATIONS = '/locations/locations/'

export const ADVERTISER_HOME_PAGE_DETAILS = '/classifieds/recruiter_home_page/'

export const ADVERTISER_SUBMIT_JOB = [
  '/submissions/v3/create_submission/',
  '/submissions/v4/submissions/'
]

export const ADVERTISER_PARAMETERS_LOG = '/submissions/advertisers_parameters_log/'

export const SMS_SENT_URL = '/notifications/send_sms/'

// MicroLocationsAPI
export const MICRO_LOCATION_SEARCH = '/locations/cities/search_as_you_type/'

export const GET_lOCATION_LIST = '/locations/cities/'

export const MICRO_LOCALITIES_SEARCH = '/locations/localities/search_as_you_type/'

export const ALL_MICRO_LOCALITIES_SEARCH = '/locations/localities/'

export const LAT_LONG_LOCATION_SEARCH = '/locations/localities/search_latlong/'

export const CLASSIFIED_PLANS = '/classifieds/v2/packages/'

export const POPULAR_CITIES = '/locations/popular/cities/'

// Razorpay
export const RAZORPAY_CREATE_ORDER = '/payments/razorpay/order/'
export const RAZORPAY_ORDER_VALIDATE = '/payments/razorpay/validate/'

export const ORDER_SUMMARY = '/advertisers/v1/payment/link/checkout/'

export const optionTypes = {
  checkBox: ['Salary', 'Qualification', 'Job type', 'Preferred Location'],
  radio: ['Shift timing', 'Experience', 'Freshness', 'Fees Charged', 'Gender', 'Job Category']
}

export const specialisationIds = [73, 69, 72]

export const jobDetailsIcons = {
  Salary: { url: 'salaryIconInJobDetails', width: 18, height: 18 },
  Location: { url: 'locationIcon', width: 18, height: 18 },
  Hours: { url: 'jobHoursIcon', width: 13.5, height: 13.5 },
  Shift: { url: 'shiftIcon', width: 18, height: 18 },
  Experience: { url: 'experienceIcon', width: 16, height: 16 },
  Education: { url: 'qualificationIcon', width: 16, height: 16 },
  Gender: { url: 'genderIcon', width: 18, height: 18 },
  Openings: { url: 'openingsIcon', width: 18, height: 18 }
}

export const pathNameWithPageTitle = {
  jobsFiltering: ['Jobs'],
  sitemap: ['Sitemap'],
  sponsoredJobs: ['Sponsored Jobs']
}

export const NO_HEADER_PAGES = [
  'location',
  'create_profile',
  'advertiserHomePage',
  'advertiserPostJob',
  'advertiserLogin',
  '404',
  'seekerHomePage'
]

export const SECONDARY_HEADERS = {
  jobProfile: 'Job Profile',
  jobDetails: 'Job Detail'
}

export const jobProfileRequiredFields = {
  1: [
    { field: 'gender', array: false },
    { field: 'name', array: false },
    { field: 'qualification', array: false }
  ],
  2: [{ field: 'experience', array: false }],
  3: [
    { field: 'job_type', array: false },
    { field: 'work_time', array: false },
    { field: 'shift_timing', array: false },
    { field: 'job_category', array: true },
    { field: 'locations', array: true }
  ]
}

export const POST_JOB_LINK =
  'https://jobs.getlokalapp.com/submissions/home/?utm_source=facebook_webform_26thsept&utm_campaign=fb_engagement_26thsept'

const footerLocationIds = JSON?.parse(process?.env?.NEXT_PUBLIC_FOOTER_LOCATION_IDS)

export const footerLocations = {
  guntur: {
    color: null,
    id: footerLocationIds?.[0],
    image: 'https://s3.ap-south-1.amazonaws.com/getlokal-output/locations/20_guntur.jpg',
    locale: ['te'],
    places: null,
    short_name: 'guntur',
    title: 'guntur',
    type: 1
  },
  krishna: {
    color: null,
    id: footerLocationIds?.[1],
    image:
      'https://s3.ap-south-1.amazonaws.com/getlokal-output/locations/None_krishna_district.jpeg',
    locale: ['te'],
    places: 'గుడివాడ, జగ్గయ్యపేట, మచిలీపట్టణం, తిరువూరు, ...',
    short_name: 'krishna',
    title: 'krishna',
    type: 1
  },
  Vishakapatnam: {
    color: null,
    id: footerLocationIds?.[2],
    image: 'https://s3.ap-south-1.amazonaws.com/getlokal-output/locations/None_vishakapatnam.jpg',
    locale: ['te'],
    places: null,
    short_name: 'Vishakapatnam',
    title: 'Vishakapatnam',
    type: 1
  },
  yadadri: {
    color: null,
    id: footerLocationIds?.[3],
    image: 'https://s3.ap-south-1.amazonaws.com/getlokal-output/locations/None_yadadri.jpg',
    locale: ['te'],
    places: 'బీబీనగర్, మోత్కూర్, యాదగిరిగుట్ట, ...',
    short_name: 'yadadri',
    title: 'yadadri',
    type: 1
  }
}

const footerCategoriesIds = JSON?.parse(process?.env?.NEXT_PUBLIC_FOOTER_CATEGORY_IDS)

export const footerCategories = {
  Design: {
    id: footerCategoriesIds[0],
    title: 'Designers',
    english_name: 'Designing',
    order_id: null,
    type: 1004,
    filter_value: [footerCategoriesIds[0]]
  },
  Finance: {
    id: footerCategoriesIds[1],
    title: 'Finance',
    english_name: 'Finance',
    order_id: null,
    type: 1004,
    filter_value: [footerCategoriesIds[1]]
  },
  Administration: {
    id: footerCategoriesIds[2],
    title: 'Administration',
    english_name: 'Admin/Office Assistant',
    order_id: null,
    type: 1004,
    filter_value: [footerCategoriesIds[2]]
  },
  'Digital Marketing': {
    id: footerCategoriesIds[3],
    title: 'Digital Marketing',
    english_name: 'Digital/Online Marketing',
    order_id: null,
    type: 1004,
    filter_value: [footerCategoriesIds[3]]
  }
}
export const LIST_DATA = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]

export const DISCLAIMER =
  'Before you apply for any jobs, we are requesting Lokal app users to please verify the details carefully. Lokal app does not promise a job or an interview in exchange for money. In case, any payment is done to any recruiter that will be the sole responsibility of the job seeker. Any such fraud company reported will be blacklisted on the platform and we as a company has a right to take legal action against such companies on this notice. In case of any doubts/concerns please'

export const SORT_IGNOR = [1, 15, 16, 3, 10, 17]

export const CONNECTION_TOAST = {
  isVisible: true,
  details: {
    content: 'No internet connection',
    title: 'Connection',
    timeOut: 3000,
    placement: 'bottom'
  }
}

export const POST_SUBMITTED_TOAST = {
  isVisible: true,
  details: {
    content: '',
    title: 'Post submitted for review',
    timeOut: 3000,
    placement: 'bottom'
  }
}

export const PROFILE_ERROR_TOAST = {
  isVisible: true,
  details: {
    content: 'Something went wrong while saving the details. Please try again.',
    title: 'Job Profile',
    timeOut: 3000,
    placement: 'top'
  }
}

export const APPLY_JOB_ERROR_TOAST = {
  isVisible: true,
  details: {
    content: 'Something went wrong while applying. Please try again.',
    title: 'Apply Job',
    timeOut: 3000,
    placement: 'top'
  }
}

export const LOGIN_DEFAULT_DETAILS = {
  id: null,
  jobsUserId : null,
  isLogIn: false,
  mobileNumber: '',
  name: 'Name',
  whatsAppOptIn: false
}

export const EMAIL_US = 'jobsupport@getlokalapp.com'

export const SITE_MAP_SECTIONS = {
  category: 'Jobs by category',
  location: 'Jobs by location'
}

export const DEFAULT_BODY = { apiBody: {}, selectedOptions: {} }

export const DEFAULT_HEADER_WITH_BORDER = ['sitemap']

export const FrequentlyAskedQuesData = [
  {
    header: 'How can I get a job using the Lokal app?',
    content: [
      'Searching for jobs on the Lokal app is simple.Follow these steps to get job using local app .',
      '1. Log in using your phone number and complete your profile.',
      '2. Choose job categories that match your skills.',
      '3. Find the job of your choice and apply.',
      '4. Call HR to schedule an interview.'
    ]
  },
  {
    header: 'What types of jobs are available locally?',
    content: [
      'Some of the more popular domains that are a good fit local job search include',
      'Admin / office, Telecalling / BPO, Delivery driver, Marketing & Sales, Computer / Data Entry Executive, Househelp, Factory worker, Accountant / Finance, Beautician, Cook / Chef, Business development / Operations and more job openings are available.'
    ]
  },
  {
    header: 'Where can I find a job via the Lokal app?',
    content: [
      'Our reach extends to 70+ cities, including Ahmedabad, Bangalore, Chennai, Hyderabad, Kolkata, Mumbai, and Pune. Tailor your job search by location and job category on our app to discover relevant openings in your city. Stay updated with job alerts and seize the latest vacancies from a pool of 10,000+ daily additions. Apply swiftly and secure your dream job.'
    ]
  },
  {
    header: 'Which categories job seekers can apply for?',
    content: [
      'Explore a wide range of job opportunities suitable for 10th or 12th pass individuals, fresh graduates seeking part-time employees  or online work, as well as experienced professionals. Find the perfect job opening that matches your qualifications and preferences.'
    ]
  }
]

export const JOB_PROFILE_KEYS = {
  1: ['name', 'gender', 'qualification', 'specialization', 'resume'],
  2: ['past_employer', 'recent_designation', 'experience', 'salary'],
  3: ['job_type', 'work_time', 'shift_timing', 'job_category', 'locations']
}

export const LOADER_EXCLUDE = ['/jobs', '/jobs-menu', '/hire/post-job', '/hire']

export const ADVERTISER_SKILLS = '/classifieds/v1/primary-job-roles/'

export const CANDIDATE_TYPE = 'candidateType'

export const SEEKER = 'seeker'

export const ADVERTISER = 'advertiser'